import { useState, useEffect } from 'react';

const useLinkedNarratives = (
  narratives,
  contentId,
  isChangedNarratives = false
) => {
  const [linkedNarrativesChanged, setLinkedNarrativesChanged] = useState(false);
  const [originalNarratives, setOriginalNarratives] = useState(null);

  useEffect(() => {
    if (narratives && contentId) {
      const filterByIsConnectedToParent = (narrative) => {
        return (
          narrative &&
          narrative.links &&
          narrative.links.some(
            (link) =>
              link.id === parseInt(contentId, 10) &&
              (link.linked === undefined || link.linked === true)
          )
        );
      };

      const narrativeCompositeKey = (narrativesToTransform) =>
        Object.values(narrativesToTransform)
          .flat()
          .filter((narrative) => filterByIsConnectedToParent(narrative))
          .map((narrative) => narrative.contentThreadId)
          .sort()
          .join(',');

      const newNarratives = narratives ? narrativeCompositeKey(narratives) : '';

      if (originalNarratives === null) {
        setOriginalNarratives(narrativeCompositeKey(narratives));
      } else if (newNarratives !== originalNarratives) {
        setLinkedNarrativesChanged(true);
      } else {
        setLinkedNarrativesChanged(false);
      }
    }
  }, [narratives, contentId, originalNarratives, isChangedNarratives]);

  return linkedNarrativesChanged;
};

export default useLinkedNarratives;
